import { render, staticRenderFns } from "./MyPageInterest.vue?vue&type=template&id=627a1dac&scoped=true&"
import script from "./MyPageInterest.vue?vue&type=script&lang=js&"
export * from "./MyPageInterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627a1dac",
  null
  
)

export default component.exports